import { IFileObject } from '@components/block/Quest/Download/Download';
import { useOpenQuestionnaireMutation } from '@dieterApi/questionnaire/useOpenQuestionnaireMutation';
import { useQuestionnaireDownloadDocxV2Mutation } from '@dieterApi/questionnaire/useQuestionnaireDownloadDocxV2Mutation';
import download from 'downloadjs';
import sanitize from 'sanitize-filename';

export function downloadFile({ mimeType, fileName, fileBase64 }: IFileObject) {
  return download(`data:${mimeType};base64,${fileBase64}`, sanitize(fileName), mimeType);
}

/**
 * Hook for downloading questionnaire as DOCX using the new HTML-first approach.
 * Uses local questionnaire ID (not the remote legalOS questionnaireId).
 */
export function useDownload(): [(localQuestionnaireId: string) => void, boolean] {
  const [openQuestionnaire] = useOpenQuestionnaireMutation();
  const [downloadDocx, { loading }] = useQuestionnaireDownloadDocxV2Mutation();

  return [
    async function (localQuestionnaireId: string) {
      // First, validate/recreate questionnaire on legalOS if needed
      await openQuestionnaire({
        variables: { localQuestionnaireId },
      });
      // V2 mutation uses local ID for HTML-first rendering
      downloadDocx({
        variables: {
          id: localQuestionnaireId,
        },
      }).then((result) => {
        if (result.data?.questionnaireDownloadDocxV2) {
          downloadFile(result.data.questionnaireDownloadDocxV2);
        }
      });
    },
    loading,
  ];
}
